import { render, staticRenderFns } from "./home.vue?vue&type=template&id=7eb2bc79&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=7eb2bc79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb2bc79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eb2bc79')) {
      api.createRecord('7eb2bc79', component.options)
    } else {
      api.reload('7eb2bc79', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=7eb2bc79&scoped=true", function () {
      api.rerender('7eb2bc79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home.vue"
export default component.exports